module.exports = __webpack_public_path__ + "static/media/alertMarker.acd2b6bf.svg";